/**
 * @generated SignedSource<<f9c30cb1dccac38b35cebfa0e6b2f8c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarButtons_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_user" | "PdpSharedMakeOfferButton_user" | "PdpSharedShoppingButtons_user" | "SharedSaveSearchContext_user">;
  readonly " $fragmentType": "PdpRespSidebarButtons_user";
};
export type PdpRespSidebarButtons_user$key = {
  readonly " $data"?: PdpRespSidebarButtons_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarButtons_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShoppingButtons_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedSaveSearchContext_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5a3597701fadcf0317551d11a80524eb";

export default node;
